import React, { Component } from 'react'
import '../styles/MarketChainStudy.css'
import OrgFooter from '../widgets/OrgFooter'
import DropdownWidget from '../widgets/DropdownWidget'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import DatePicker from '../widgets/DatePicker'
import APISiteRequest from '../api/APISiteRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'
import deleteIcon from '../images/delete.png'
import addIcon from '../images/add.png'
import SupplyPlanCommitment from './SupplyPlanCommitment'

class SupplyPlanForm extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			clusterId: sessionStorage.getItem("cluster-id"),
			siteId: props.siteId,
			scrollable: false,
			mop: "-- SELECT --",
			targetCrop: "-- SELECT --",
			unit: "-- SELECT --",
			frequency: "DOES NOT REPEAT",
			frequencyId: 1,
			repeatEvery: 0,
			unitPrice: 0.0,
			volume: 0,
			disabled: props.disabled,
			pbid: props.pbid,
			itemObjTB: {},
			buyers: [],
			targetBuyers: {},
			deleteTargetBuyers: {},
			itemObjCL: {},
			clusters: [],
			clusterNames: {},
			deleteClusterNames: {},
			overlayHeight: "100%",
			title: "ADD"
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.getAllCrops = this.getAllCrops.bind(this)
		this.getProspectiveBuyerById = this.getProspectiveBuyerById.bind(this)
		this.handleFooterEvent = this.handleFooterEvent.bind(this)
		this.setTargetBuyers = this.setTargetBuyers.bind(this)
		this.eventHandlerTB = this.eventHandlerTB.bind(this)
		this.setClusterNames = this.setClusterNames.bind(this)
		this.eventHandlerCL = this.eventHandlerCL.bind(this)
		this.setScrollable = this.setScrollable.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		if(this.state.targetBuyer == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Target Market/Buyer is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.cropId == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Target crop is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.qualityReq == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Output quality requirement is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.unitPrice == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Unit price is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.volume == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Volume is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.unitId == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Unit of measurement is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.mop == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Mode of payment is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.deliveryDate == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Delivery date is required.",
				showActivityIndicator: false
			})
			return
		}
		const data = {
			"site_id": this.state.siteId,
			"crop_id": this.state.cropId,
			"target_market_name": this.state.targetBuyer.toUpperCase(),
			"output_quality_req": this.state.qualityReq,
			"unit_price": this.state.unitPrice,
			"measurement_id": this.state.unitId,
			"volume": this.state.volume,
			"mode_of_payment_id": this.state.mopId,
			"notes_on_payment": this.state.notes,
			"delivery_date": this.state.deliveryDate,
			"repeat_every": this.state.repeatEvery,
			"delivery_frequency_id": this.state.frequencyId,
			"on_the_following_days": this.state.days,
			"delivery_end_date": this.state.deliveryEnd
		}
		if(this.state.prospectiveBuyerId == null) {
			const apiReq = APISiteRequest.addProspectiveBuyerBySiteId(this.state.accessToken, data, this.state.siteId)
			apiReq.then((response) => {
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
			})
		}
		else {
			const apiReq = APISiteRequest.editProspectiveBuyerById(this.state.accessToken, data, this.state.prospectiveBuyerId)
			apiReq.then((response) => {
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
			})
		}
	}

	handleFooterEvent(e) {
		if(e === "UPDATE") {
			this.setTargetBuyers(null, false)
			this.setClusterNames(null, false)
			this.setState({disabled: false, title: "UPDATE"})
		}
		else {
			this.props.handleFooterEvent(e)
		}
	}

	componentWillMount() {
		this.getAllCrops()
		this.getProspectiveBuyerById()
		this.setTargetBuyers(null, this.state.disabled)
		this.setClusterNames(null, this.state.disabled)
	}

	getAllCrops() {
		const types = APIFarmerRequest.getAllCrops(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.crop_id, name: v.name})
			}
			localStorage.setItem("crops", JSON.stringify(c))
			this.setState({crops: c})
		})
	}

	getProspectiveBuyerById() {
		const apiReq = APISiteRequest.getProspectiveBuyerById(this.state.accessToken, this.state.pbid)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			if(response.results.on_the_following_days != null) {
				var tbDefault = response.results.on_the_following_days.split(',').map((item) => {
					return(parseInt(item, 6))
				})
			}
			this.setState({
				prospectiveBuyerId: response.results.trn_mcs_prospective_buyers_id,
				targetBuyer: response.results.target_market_name,
				targetCrop: response.results.crop,
				cropId: response.results.crop_id,
				qualityReq: response.results.output_quality_req,
				unitPrice: parseInt(response.results.unit_price),
				volume: parseInt(response.results.volume),
				unit: response.results.measurement.toUpperCase(),
				mop: response.results.mode_of_payment,
				noteOnPayment: response.results.notes_on_payment,
				deliveryDate: response.results.delivery_date,
				repeatEvery: parseInt(response.results.repeat_every),
				frequencyId: response.results.delivery_frequency_id, 
				deliveryEnd: response.results.delivery_end_date,
				tbDefault: tbDefault,
				days: response.results.on_the_following_days,
				unitId: response.results.measurement_id,
				mopId: response.results.mode_of_payment_id
			})
			const elem = document.getElementById('ta-note')
			elem.style.height = "20px"
			elem.style.height = (elem.scrollHeight - 4) + "px"
		})
	}

	setTargetBuyers(targetBuyers, disabled) {
		const buyers = []
		const itemObjTB = {}
		if(targetBuyers != null) {
			for(const v of targetBuyers) {
				const k = "tb-" + Math.random()
				itemObjTB[k] = <TargetBuyer data={v} handler={this.eventHandlerTB}
					disabled={disabled} key={k} id={k} />
			}
			const k = "tb-" + Math.random()
			itemObjTB[k] = <TargetBuyer handler={this.eventHandlerTB}
				disabled={disabled} key={k} id={k} />
			Object.keys(itemObjTB).forEach((k => {
				buyers.push(itemObjTB[k])
			}))
		}
		else {
			const k = "tb-" + Math.random()
			itemObjTB[k] = <TargetBuyer handler={this.eventHandlerTB}
				disabled={disabled} key={k} id={k} />
			buyers.push(itemObjTB[k])
		}
		this.setState({buyers: buyers, itemObjTB: itemObjTB})
	}

	eventHandlerTB(e, compId, key, value) {
		switch(e) {
			case "buyer":
				this.state.targetBuyers[compId] = value
				break
			case "add":
				this.state.targetBuyers[compId] = value
				const added = []
				const k = "tb-" + Math.random()
				this.state.itemObjTB[k] = <TargetBuyer handler={this.eventHandlerTB} key={k} id={k} />
				Object.keys(this.state.itemObjTB).forEach((k => {
					added.push(this.state.itemObjTB[k])
				}))
				this.setState({buyers: added})
				break
			case "delete":
				this.state.deleteTargetBuyers[compId] = value
				delete this.state.targetBuyers[compId]
				delete this.state.itemObjTB[compId]
				const deleted = []
				Object.keys(this.state.itemObjTB).forEach((k => {
					deleted.push(this.state.itemObjTB[k])
				}))
				this.setState({buyers: deleted})
		}
		this.setScrollable()
	}

	setClusterNames(clusterNames, disabled) {
		const clusters = []
		const itemObjCL = {}
		if(clusterNames != null) {
			for(const v of clusterNames) {
				const k = "cl-" + Math.random()
				itemObjCL[k] = <Cluster data={v} handler={this.eventHandlerCL}
					onClick={(id) => { this.setState({showCommitment: true}) }}
					disabled={disabled} key={k} id={k} />
			}
			const k = "cl-" + Math.random()
			itemObjCL[k] = <Cluster handler={this.eventHandlerCL}
				onClick={(id) => { this.setState({showCommitment: true}) }}
				disabled={this.state.disabled} key={k} id={k} />
			Object.keys(itemObjCL).forEach((k => {
				clusters.push(itemObjCL[k])
			}))
		}
		else {
			const k = "cl-" + Math.random()
			itemObjCL[k] = <Cluster handler={this.eventHandlerCL}
				onClick={(id) => { this.setState({showCommitment: true}) }}
				disabled={disabled} key={k} id={k} />
			clusters.push(itemObjCL[k])
		}
		this.setState({clusters: clusters, itemObjCL: itemObjCL})
	}

	eventHandlerCL(e, compId, key, value) {
		switch(e) {
			case "buyer":
				this.state.clusterNames[compId] = value
				break
			case "add":
				this.state.clusterNames[compId] = value
				const added = []
				const k = "cl-" + Math.random()
				const obj = this.state.itemObjCL.keys
				this.state.itemObjCL[k] = <Cluster handler={this.eventHandlerCL}
					onClick={(id) => { this.setState({showCommitment: true}) }}
					key={k} id={k} />
				Object.keys(this.state.itemObjCL).forEach((k => {
					added.push(this.state.itemObjCL[k])
				}))
				this.setState({clusters: added})
				break
			case "delete":
				this.state.deleteClusterNames[compId] = value
				delete this.state.clusterNames[compId]
				delete this.state.itemObjCL[compId]
				const deleted = []
				Object.keys(this.state.itemObjCL).forEach((k => {
					deleted.push(this.state.itemObjCL[k])
				}))
				this.setState({clusters: deleted})
		}
		this.setScrollable()
	}

	setScrollable() {
		const sa = document.getElementById('spf-scroll-area')
		const ca = document.getElementById('spf-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+60) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	render() {
		const view = <div id="supply-plan-form">
			<div id="spf-scroll-area"><div id="spf-client-area">
				<div className="title-bar">{!this.state.disabled && <span>{this.state.title} </span>}SUPPLY PLAN</div>
				{/* <div className="title-bar">{this.state.supplyPlanId == null && <span>ADD </span>}SUPPLY PLAN</div> */}
				<div id="spf-cell1">
					<div className="spf-cell1-row">
						<div id="spf-cell1-r1-i1">
							<div>Supply Plan ID *</div>
							<input type="text" placeholder={this.state.targetBuyer} onChange={(e) => {
								this.setState({targetBuyer: e.target.value})
							}} disabled={this.state.disabled} />
						</div>
						<div id="spf-cell1-r1-i2">
							<div>Target Crop *</div>
							<DropdownWidget list={this.state.crops} placeholder={this.state.targetCrop} cStyle={{"width": "100%"}}
								onItemSelected={(id, val) => {
									this.setState({cropId: id})
								}} disabled={this.state.disabled} />
						</div>
						<div id="spf-cell1-r1-i3">
							<div>Start Date *</div>
							<DatePicker value={this.state.startDate} onChange={(value) => {
								this.setState({startDate: value})
							}} disabled={this.state.disabled} />
						</div>
					</div>
				</div>
				<div id="spf-btm-cell">
					<div id="spf-cell2">
						<div style={{'margin-left': '27px'}}>Target Buyers</div>
						<div id="spf-buyers">{this.state.buyers}</div>
					</div>
					<div id="spf-cell3">
						<div id="spf-cell3-lbl">
							<span style={{'flex-basis': '65%'}}>Cluster Name</span><span>Date</span>
						</div>
						{this.state.clusters}
					</div>
				</div>
			</div>
			{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
				eventHandler={this.handleFooterEvent}
					showSubmit={!this.state.disabled}
					showCancel={!this.state.disabled}
					showClose={this.state.disabled}
					showUpdate={this.state.disabled}/>}
			</div>
			{this.state.scrollable === false && <div className="alternate-footer">
				<OrgFooter submit={this.onSubmit} eventHandler={this.handleFooterEvent}
					showSubmit={!this.state.disabled}
					showCancel={!this.state.disabled}
					showClose={this.state.disabled}
					showUpdate={this.state.disabled}/></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => { this.setState({showInfoMessage: false}) }} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			<ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />
			<SupplyPlanCommitment show={this.state.showCommitment} hide={() => {this.setState({showCommitment: false})}} />
		</div>
		return(view)
	}
}

class TargetBuyer extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			disabled: props.disabled,
			buyerData: {},
			buyer: "-- SELECT --"
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
		// this.getARBOServices = this.getARBOServices.bind(this)
	}

	componentWillMount() {
		// this.getARBOServices()
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.buyerData["id"] = this.props.data.id
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.setState({
				buyer: this.props.data.prospective_buyer,
				addDeleteButton: addDeleteButton
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.buyerData)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		this.props.handler("delete", this.state.itemId, null, this.state.buyerData)
	}

	// getARBOServices() {
	// 	const c = JSON.parse(localStorage.getItem("services"))
	// 	if(c != null) {
	// 		this.setState({services: c})
	// 		return
	// 	}
	// 	const resp = APIOrganizationRequest.getAllARBOServices(this.state.accessToken)
	// 	resp.then((response) => {
	// 		if(response.status === "FAILED") {
	// 			return
	// 		}
	// 		const c = []
	// 		for(const v of response.results.rows) {
	// 			c.push({id: v.arbo_service_id, name: v.name})
	// 		}
	// 		localStorage.setItem("services", JSON.stringify(c))
	// 		this.setState({services: c})
	// 	})
	// }

	render() {
		const view = <div className="target-buyer">
			<div>{this.state.addDeleteButton}</div>
			<DropdownWidget list={this.state.buyers} placeholder={this.state.buyer}
				cStyle={{"width": "calc(100% - 5px)"}} onItemSelected={(id, val) => {
					this.state.buyerData["prosptective_buyer_id"] = id
					this.props.handler("buyer", this.state.itemId, null, this.state.buyerData)
					if(this.state.addDeleteButton.props.alt == "ADD") {
						this.onAddItemClick()
					}
				}} disabled={this.state.disabled} />
		</div>
		return(view)
	}
}

class Cluster extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			disabled: props.disabled,
			clusterData: {},
			cluster: "-- SELECT --"
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.clusterData["id"] = this.props.data.id
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.setState({
				cluster: this.props.data.cluster_name,
				addDeleteButton: addDeleteButton
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.clusterData)
		this.setState({
			addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />,
			showButton: true
		})
	}

	onDeleteItem() {
		this.props.handler("delete", this.state.itemId, null, this.state.clusterData)
	}

	// closeOverlay() {
	// 	this.setState({
	// 		overlayContent: null,
	// 		overlayHeight: "0%"
	// 	})
	// }

	render() {
		const view = <div className="cluster-name">
			<div>{this.state.addDeleteButton}</div>
			<table className="spf-table-data">
				<col style={{width: '65%'}} />
				<col style={{width: '35%'}} />
				<tr>
				<td><DropdownWidget list={this.state.cluster} placeholder={this.state.cluster}
					cStyle={{"width": '100%'}} onItemSelected={(id, val) => {
						this.state.clusterData["cluster_id"] = id
						this.props.handler("cluster", this.state.itemId, null, this.state.clusterData)
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
					}} disabled={this.state.disabled} />
				</td>
				<td><DropdownWidget list={this.state.cluster} placeholder={this.state.cluster}
					cStyle={{"width": '100%'}} onItemSelected={(id, val) => {
						this.state.clusterData["date"] = val
						this.props.handler("cluster", this.state.itemId, null, this.state.clusterData)
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
					}} disabled={this.state.disabled} />
				</td>
			</tr></table>
			{this.state.showButton && <button onClick={(e) => {
				this.props.onClick(this.state.itemId)
			}}>ENCODE COMMITMENTS</button>}
			{!this.state.showButton && <button className="hidden-btn">ENCODE COMMITMENTS</button>}
		</div>
		return(view)
	}
}

export default SupplyPlanForm
